











































































































































































import { Mixins, Component } from 'vue-mixin-decorator';
import DialogConnector from '@/connector/Dialog.vue';
import AuthConnector from '@/connector/Auth.vue';
import ProfileConnector from '@/connector/Profile.vue';
import LuanchGameMixin from '@/mixins/luanchGameMixin';

@Component({
  components: {
    DialogConnector,
    AuthConnector,
    ProfileConnector,
  },
})
export default class BaseTopNavigatorBar extends Mixins<LuanchGameMixin>(LuanchGameMixin) {
  // eslint-disable-next-line class-methods-use-this
  get menus(): Array<{ title: string; subtitle: string; icon: string; link: string }> {
    return [
      {
        title: 'SLOT', subtitle: 'สล็อตเกมส์', icon: 'slot', link: '/slot',
      },
      {
        title: 'LIVE CASINO', subtitle: 'คาสิโนสด', icon: 'casino', link: '/live',
      },
      {
        title: 'FISHING', subtitle: 'ยิงปลา', icon: 'fishing', link: '/fishing',
      },
      {
        title: 'CASUAL', subtitle: 'สกิลเกมส์', icon: 'casual', link: '/casual',
      },
      {
        title: 'P2P', subtitle: 'แข่งกับผู้เล่นอื่น', icon: 'p2p', link: '/p2p',
      },
    ];
  }
}
